<fieldset *ngrxLet="signature$; let signature" [formGroup]="signatureForm">
    <div class="row mb-3">
        <div class="col">
            <p>{{ signature.description }}</p>
        </div>
    </div>
    <div class="row mb-3">
        <span class="col-md-2 col-form-label col-4 text-start">{{ signature.label }}</span>
        <div class="col-md-auto col-12">
            <!-- we need to add the height and width of the canvas directly in the html.
      https://stackoverflow.com/questions/51805385/not-getting-actual-canvas-height-and-width-and-fillrect-is-blurred-out-->
            <canvas
                #signatureCanvas
                [height]="120"
                [ngClass]="{
                    'ng-invalid': !signaturePad || (signaturePad.isEmpty && firstNameControl.enabled),
                    disabled: firstNameControl.disabled,
                }"
                [width]="300"
                class="cse-signature-canvas signature-canvas"
            ></canvas>
        </div>
        <div class="col-md-auto col-6 pt-md-0 pt-3">
            <button
                (click)="clearSignature()"
                [disabled]="signature.disabled || (readOnly$ | async)"
                class="btn btn-secondary btn-lg"
                translate="F4M_SUMMARY_MODAL_CLEAR_LABEL"
                type="button"
            ></button>
        </div>
        @if (displayNACheckboxForCustomerSignature$ | async) {
            <div class="col-md-auto col-4 pt-md-0 pt-4 ps-2">
                <div class="not-applicable">
                    <div class="checkbox-container">
                        <input
                            #checkbox
                            [formControl]="checkboxControl"
                            class="form-control"
                            id="system-condition-signature-not-application"
                            type="checkbox"
                        />
                        @if (checkbox.checked) {
                            <fa-icon (click)="checkbox.click()" [icon]="faCheck" size="2x"></fa-icon>
                        }
                    </div>
                    <label
                        for="system-condition-signature-not-application"
                        translate="F4M_NOT_APPLICABLE_LABEL"
                    ></label>
                </div>
            </div>
        }
        @if (displayHistoryButton$ | async) {
            <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                <pace-forms-history-button [uniqueId]="signature.uniqueId"></pace-forms-history-button>
            </div>
        }
    </div>
    <div class="row mb-3">
        <label
            class="col-md-2 col-4 text-start col-form-label"
            for="{{ signature.nameXmlId }}-firstName"
            translate="SYSTEM_CONDITION_SIGNATURE_FIRST_NAME_LABEL"
        ></label>
        <div class="col-md-10 col-12">
            <input
                [formControl]="firstNameControl"
                class="form-control input-md name-input"
                id="{{ signature.nameXmlId }}-firstName"
                type="text"
            />
        </div>
    </div>
    <div class="row mb-3">
        <label
            class="col-md-2 col-4 col-form-label text-start"
            for="{{ signature.nameXmlId }}-lastName"
            translate="SYSTEM_CONDITION_SIGNATURE_LAST_NAME_LABEL"
        ></label>
        <div class="col-md-10 col-12">
            <input
                [formControl]="lastNameControl"
                class="form-control input-md name-input"
                id="{{ signature.nameXmlId }}-lastName"
                type="text"
            />
        </div>
    </div>
</fieldset>
